<template>
  <div
    class="ks-ky-container"
    :class="{
      // 'ks-ky-container--black': !isWhite,
      'ks-ky-container--white': isWhite,
    }"
  >
    <div ref="wrapper">
      <img class="header__icon" :src="Icons.leftArrow" @click="handleBack" />
      <img class="galaxy galaxy--right" :src="Icons.galaxyRight" />
      <img class="galaxy galaxy--left" :src="Icons.galaxyLeft" />
      <div ref="logoWrapper" class="logo__wrapper">
        <img class="logo__img" :src="Icons.logo" />
      </div>
      <div
        ref="videoWrapper"
        :style="{ height: videoWrapperHeight }"
        class="video__wrapper"
      >
        <div class="video__wrapper__center">
          <div class="video__wrapper__bg" :style="{ ...videoStyle }"></div>
          <img
            v-if="!videoStatus && startControlling"
            :src="Icons.playIcon"
            class="video__icon"
            @click.stop="handleVideoStatus"
          />
          <!-- 兼容无法自动播放的情况 -->
          <div v-if="!startControlling && !videoLoading && !canAutoPlay">
            <div class="video__poster__wrapper">
              <div
                class="video__poster__background"
                :style="{
                  'background-image': `url(${data.coverUrl})`,
                  ...videoStyle,
                }"
              >
                <img
                  :src="Icons.playIcon"
                  class="video__icon"
                  @click.stop="handleVideoStatus"
                />
              </div>
            </div>
          </div>
          <div v-if="videoLoading" class="video__background">
            <img
              src="@/assets/img/loading-black.svg"
              class="video__loading__img"
            />
          </div>
          <video
            ref="videoPlayer"
            class="video__item"
            :class="{ 'video__item--hide': videoLoading }"
            :style="videoStyle"
            :autoplay="true"
            :loop="true"
            :muted="videoLoading"
            webkit-playsinline="true"
            x-webkit-airplay="true"
            playsinline="true"
            poster=""
            x5-playsinline
            :src="data.videoUrl"
            @click.stop="handleVideoStatus"
            @timeupdate="handleVideoTimeupdate"
            @playing="handleVideoPlaying"
          ></video>
        </div>
      </div>
    </div>
    <div ref="btnRef" class="info__wrapper">
      <div class="info__header">
        <span class="info__header--left">
          {{ data?.title }}
        </span>
        <span class="info__header--right">
          {{ data?.useCount }}
        </span>
      </div>
      <div class="info__content">
        {{ data?.subtitle }}
      </div>
    </div>
    <button class="btn__item" @click="goToStore">
      {{ data?.buttonText }}
    </button>
  </div>
</template>

<script>
/* eslint camelcase: ["off"] */
// import Cookies from 'js-cookie'
import qs from 'query-string'
import crypto from '@/utils/crypto'
import Icons from '@/components/kskyIcon'
import { getKsDeviceInfo, ksHasInstalledKwai } from '@/utils/tools'
import { Device } from '@/utils/device'
import { invoke } from '@yoda/bridge'

export default {
  async setup() {
    useHead({
      script: [{ src: '/js/flexible.js', type: 'text/javascript' }],
    })
    const { data } = await useAsyncData(async (params) => {
      const route = useRoute()
      const config = useRuntimeConfig()
      const host = config.public.VITE_KY_API_HOST
      const {
        template_id,
        session_id: sessionId,
        type,
        kytheme,
        query_word,
      } = route.query
      let cryptoMessage = crypto()
      if (typeof cryptoMessage !== 'string') {
        cryptoMessage = qs.stringify(cryptoMessage)
      }

      console.log('===111')
      const res = await $fetch(
        `http://pg.kmovie-api.internal/rest/n/kmovie/app/plc/transfer?contentId=${encodeURIComponent(
          template_id
        )}&sessionId=${sessionId}&contentType=${type}&${cryptoMessage}`
      )
      const {
        videoUrl,
        buttonDoc,
        androidDownloadUrl,
        kwaiLink,
        coverUrl,
        subtitle,
        title,
        useCount,
      } = res.data || {}
      return {
        isWhite: true,
        Icons: Icons('white'),
        videoUrl,
        buttonText: buttonDoc || '轻松做同款',
        androidDownloadUrl,
        schema: kwaiLink,
        coverUrl,
        logData: {
          ks_deviceid: '',
          ks_uid: '',
          gid: '',
          idfa: '',
          imei: '',
          session_id: sessionId,
          video_url: videoUrl,
          tech_detail: 'h5',
          template_id,
          query_word,
        },
        title,
        subtitle,
        useCount,
        kytheme,
        photoId: template_id,
      }
    })
    console.log('===data', data.value.title)
    return {
      data,
    }
  },
  data() {
    return {
      // 确定主题
      isWhite: true,
      // 初始化图标
      Icons: Icons('white'),
      // 播放状态：true -> 播放， false -> 暂停
      videoStatus: false,
      // loading节点
      loadingArray: ['#32aacc', '#64aacc', '#96aacc', '#c8aacc', '#faaacc'],
      // 按钮文案
      buttonText: '轻松做同款',
      // 视频链接
      // video载入控制
      videoLoading: true,
      // 视频埋点相关的数据
      videoLogData: {
        // 视频循环播放的次数
        play_number: 1,
        // 视频当前播放的进度比例
        progress: 0,
        device_id: '',
        gid: '',
        // 视频的总播放时长，循环继续累加
        play_during_time: 0,
        session_id: '',
        type: '',
        type_detail: '',
        video_url: '',
        tech_detail: 'h5',
        h5_repo: 'new',
      },
      // 页面埋点相关的数据
      // 埋点文档: https://wiki.corp.kuaishou.com/pages/viewpage.action?pageId=489592864
      logData: {},
      // timeupdate节流控制
      throttleTimeupdate: false,
      // 按钮防抖控制
      debounce: false,
      // 是否为手动操控
      startControlling: false,
      hasInstalledKy: false,
      videoStyle: {},
      // canShowStore: false,
      canAutoPlay: false,
      isIOS: false,
      videoWrapperHeight: 0,
      kytheme: '',
      photoId: '',
    }
  },
  watch: {
    // 简单的对timeupdate进行节流，1s进行一次收集
    throttleTimeupdate(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.throttleTimeupdate = false
        }, 500)
      }
    },
    debounce(nv) {
      if (nv) {
        setTimeout(() => {
          this.debounce = false
        }, 500)
      }
    },
  },
  async beforeMount() {
    this.webLog('SHOW', 'ky_detail_show_alading', { ...this.logData })

    try {
      await invoke('kwai.setBounceStyle', {
        enable: false,
      })
      // this.$ksBridge.setStatusBarStyle({
      //   style: this.isWhite ? 0 : 1,
      // })
      invoke('ui.setStatusBarStyle', { style: this.isWhite ? 0 : 1 })
      // this.$ksBridge.setBounceStyle({
      //   enable: false,
      // })
      // // 单列的安卓webview layoutType=4只是让标题栏透明，实际上还在，需要手动隐藏
      // this.$ksBridge.hideNavigationBar()
      await invoke('webview.hideNavigationBar')
    } catch {}
  },
  async mounted() {
    try {
      // this.$ksBridge.setTopLeftBtn({
      //   show: false,
      // })
      await invoke('webview.setTopLeftBtn', {
        show: false,
      })
    } catch (error) {}
    nextTick(() => {
      const videoCtx = this.$refs.videoPlayer
      if (videoCtx) {
        videoCtx.addEventListener('canplay', this.videoLoadedHandler)
      }
    })
    const device = new Device()
    this.isIOS = device.isIOS
    const hasInstalledKy = await ksHasInstalledKwai()
    const data = await getKsDeviceInfo()
    const device_id = this.$cookie.get('did') || ''
    const gid = this.$cookie.get('gid') || ''
    const { idfa, imei, globalId, uuid, uid } = data || {}
    this.logData.idfa = idfa || ''
    this.logData.imei = imei || ''
    this.logData.ks_deviceid = device_id || ''
    this.logData.gid = gid || globalId || ''
    this.logData.ks_uid = uuid || uid
    // this.hasInstalledKy = hasInstalledKy
    this.videoLogData.kytheme = this.kytheme
    this.webLog('SHOW', 'ky_detail_show_alading', {
      // is_ky_new_device: hasInstalledKy ? 0 : 1,
      ...this.logData,
    })
    if (hasInstalledKy) {
      setTimeout(() => {
        window.location.href = this.data.schema
      }, 300)
    }
  },
  destroyed() {
    const videoCtx = this.$refs.videoPlayer
    if (videoCtx) {
      videoCtx.removeEventListener('canplay', this.videoLoadedHandler)
    }
  },
  methods: {
    // 计算高度，并进行适配
    setVideoHeight() {
      try {
        const { videoHeight: vh, videoWidth: vw } = this
        const videoWrapperTop = this.$refs.videoWrapper.offsetTop
        const btnTop = this.$refs.btnRef.offsetTop
        const videoHeight = btnTop - videoWrapperTop
        const height = videoHeight - 42
        if (vh > vw) {
          this.videoStyle = {
            height: `${height}px`,
            width: (height / 1.777).toFixed(2) + 'px',
          }
          this.videoWrapperHeight = `${height}px`
        } else {
          const w = window.screen.width - 108
          const h = (w * vh) / vw
          this.videoStyle = {
            height: `${h}px`,
            width: `${w}px`,
          }
          this.videoWrapperHeight = `${height}px`
        }
      } catch (err) {
        /* eslint no-console: ["off"] */
        console.error(err)
      }
    },
    async goToStore() {
      if (this.debounce) {
        return
      }
      this.debounce = true
      const { isIOS } = new Device()
      this.webLog('CLICK', 'ky_download_click_alading', {
        // is_ky_new_device: hasInstalledKy ? 0 : 1,
        ...this.logData,
        // type_play_during_time: this.videoLogData.play_during_time,
      })
      this.$request.get(
        `https://api.getkwai.com/log-server/api/v1/activity/record`,
        {
          params: {
            app: 'KUAISHOU_VIDEO_EDITOR',
            cid: 'ksht',
            mi: this.logData.idfa || this.logData.imei,
            globalId: this.logData.gid,
            activity: 'alading',
            page: 'h5',
            session_id: this.logData.session_id,
            agentId: this.logData.session_id,
            groupId: this.logData.template_id,
            unionSite: this.logData.query_word,
            fr: isIOS ? 'iOS' : 'ANDROID',
          },
        }
      )
      if (this.videoStatus) {
        const videoCtx = this.$refs.videoPlayer
        videoCtx && videoCtx.pause()
        this.videoStatus = false
        this.startControlling = true
      }
      this.$openApp(this.data.schema)
    },
    handleVideoStatus() {
      const videoCtx = this.$refs.videoPlayer
      this.startControlling = true
      if (videoCtx) {
        if (this.videoStatus) {
          this.videoStatus = false
          videoCtx.pause()
        } else {
          this.videoStatus = true
          videoCtx.play()
        }
      }
    },
    handleVideoPlaying() {
      this.videoLoading = false
      this.videoStatus = true
      this.canAutoPlay = true
      this.webLog('CLICK', 'ky_detail_play_alading', {
        ...this.logData,
        // is_ky_new_device: hasInstalledKy ? 0 : 1,
      })
    },
    // ended事件在loop开启的情况下不会触发，因此手动重新播放
    // handleVideoEnded() {
    //   const { play_number } = this.videoLogData
    //   this.videoLogData.play_number = play_number + 1
    //   const videoCtx = this.$refs.videoPlayer
    //   if (videoCtx) {
    //     videoCtx.play()
    //   }
    // },
    handleVideoTimeupdate(e) {
      this.videoLoadedHandler()
      this.videoLoading = false
      if (this.throttleTimeupdate) {
        return
      }
      const { currentTime = 0, duration = 1 } = e.target || {}
      this.videoLogData.progress = (currentTime / duration).toFixed(2)
      this.videoLogData.play_during_time = (
        currentTime +
        duration * (this.videoLogData.play_number - 1)
      ).toFixed(2)
      this.throttleTimeupdate = true
    },
    async handleBack() {
      // 获取ksBridge并调用回退
      // const hasInstalledKy = await ksHasInstalledKwai()
      this.webLog('CLICK', 'ky_return_click_alading', {
        ...this.logData,
        // is_ky_new_device: hasInstalledKy ? 0 : 1,
      })
      // 可能出现退出webview视频还在播的情况，强制暂停
      const videoCtx = this.$refs.videoPlayer
      this.startControlling = true
      if (videoCtx) {
        this.videoStatus = false
        videoCtx.pause()
      }
      try {
        // this.$ksBridge.popBack()
        await invoke('webview.popBack')
      } catch (error) {}
    },
    videoLoadedHandler() {
      const videoPlayer = this.$refs.videoPlayer
      // !this.isIOS && videoPlayer.play()
      this.videoLoading = false
      const { videoHeight, videoWidth } = videoPlayer
      this.videoHeight = videoHeight
      this.videoWidth = videoWidth
      this.setVideoHeight()
    },
    webLog(eventType, eventFlag, params) {
      this.$log &&
        this.$log.collect(eventType, eventFlag, {
          ...params,
          upload_method: 'web',
        })
      this.$nativeLog &&
        this.$nativeLog.collect(eventType, eventFlag, {
          ...params,
          upload_method: 'native',
        })
    },
  },
}
</script>
<style lang="less">
@import '@/assets/css/reset.less';
.ks-ky-container {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  padding-top: 0.8rem;
  // 公有的css
  .header {
    &__icon {
      width: 0.58rem;
      height: 0.58rem;
      box-sizing: border-box;
      position: absolute;
      left: 0.18rem;
      top: 0.89rem;
      z-index: 1000;
    }
  }
  .galaxy {
    position: absolute;

    &--right {
      right: 0;
      bottom: 2.53rem;
      width: 0.84rem;
      height: 1.62rem;
    }

    &--left {
      top: 2.75rem;
      left: 0;
      width: 0.48rem;
      height: 2.62rem;
    }
  }
  .logo {
    &__wrapper {
      width: 100%;
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
    }
    &__img {
      width: 3.46rem;
      height: 0.8rem;
    }
  }

  .video {
    &__wrapper {
      margin-top: 0.48rem;
      width: 100%;
      height: 7.5rem;
      text-align: center;
      position: relative;
      z-index: 1;
      border-radius: 0.12rem;

      &__center {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      &__bg {
        border: 0.02rem solid #ff5000;
        border-radius: 0.1rem;
        position: absolute;
        left: 50%;
        top: 0.25rem;
        transform: translateX(calc(-50% + 0.25rem));
      }
    }
    &__icon {
      width: 0.9rem;
      height: 0.9rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 3;
    }
    &__background {
      width: 100%;
      height: 100%;
      // background-color: #dadce1;
      position: absolute;
      z-index: 4;
      top: 45%;
      border-radius: 0.12rem;
    }
    &__loading {
      width: 0.2rem;
      height: 0.2rem;
      border-radius: 50%;
      display: inline-block;
      margin-left: 0;
      animation: enlarge 1s linear infinite;

      &__group {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
      }

      &--delay0 {
        animation-delay: -0.1s;
      }

      &--delay1 {
        animation-delay: -0.2s;
      }

      &--delay2 {
        animation-delay: -0.3s;
      }

      &--delay3 {
        animation-delay: -0.4s;
      }

      &--delay4 {
        animation-delay: -0.5s;
      }

      &__img {
        width: 0.5rem;
        height: 0.5rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    &__item {
      width: 4.8rem;
      height: 8.53rem;
      border-radius: 0.11rem;
      position: relative;
      z-index: 2;
      visibility: visible;
      background-color: #000;

      &--hide {
        visibility: hidden;
      }
    }

    &__poster {
      &__wrapper {
        position: absolute;
        z-index: 4;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 0.12rem;
      }

      &__background {
        background-size: contain;
        background-color: #000;
        background-position: center;
        margin: 0 auto;
        border-radius: 0.12rem;
      }
    }
  }

  .btn {
    &__item {
      position: absolute;
      bottom: 0.64rem;
      left: 50%;
      transform: translateX(-50%);
      width: 6.22rem;
      height: 0.88rem;
      background-color: #ff5000;
      color: #fff;
      line-height: 0.88rem;
      font-weight: 500;
      font-size: 0.3rem;
      text-align: center;
      border-radius: 0.44rem;
      z-index: 1;
    }
  }
  &--black {
    background-color: #191919;
  }

  &--white {
    background-color: #f8f8f8;
  }

  .info {
    &__wrapper {
      position: absolute;
      bottom: 1.9rem;
      left: 50%;
      transform: translateX(-50%);
      width: 5.62rem;
    }

    &__header {
      width: 5.32rem;
      height: auto;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      &--left {
        font-size: 0.34rem;
        font-weight: bolder;
        text-align: left;
        color: #222;
        display: inline-block;
        margin-right: 0.14rem;
      }

      &--right {
        min-width: 1rem;
        background: #ffeae0;
        border-radius: 0.04rem;
        padding: 0.07rem 0.08rem;
        font-weight: 500;
        text-align: center;
        color: #ff5000;
        font-size: 0.22rem;
        display: inline-block;
      }
    }
    &__content {
      width: 100%;
      font-size: 0.28rem;
      font-weight: 400;
      text-align: left;
      color: #666;
      line-height: 1;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-top: 0.31rem;
    }
  }
}

@media screen and (max-device-aspect-ratio: ~'9/17') {
  .video__wrapper {
    margin-top: 0.96rem !important;
    height: 9.6rem;
  }
  .video__background {
    height: 9.6rem;
  }
  .info__wrapper {
    bottom: 2.31rem !important;
  }
}

@keyframes enlarge {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(2);
    opacity: 0.3;
  }
  100% {
    transform: scale(1);
  }
}
</style>
